const isNotProduction = process.env.NODE_ENV !== 'production'

const castToValidDate = (givenValue) => {
    // need to do this as Invalid Date is truthy
    const suffix = /\d\d\d\d-\d\d-\d\d$/.test(givenValue) ? 'T12:00:00' : ''
    const date = new Date(givenValue + suffix);
    if (date.getDate()) return date;
    return false
}

const typeCasters = {
    "Must be an instance of Date": castToValidDate,
    "Must be an instance of Date or null": castToValidDate,
    "must be an integer": givenValue => parseInt(givenValue),
    "must be a number": givenValue => parseFloat(givenValue),
}

const doTypeCast = (givenValue, errorMessage) => {
    return typeCasters[errorMessage]?.(givenValue)
}

const tryToTypeCast = (givenValue, schemaErrors) => {
    const unresolved = []
    schemaErrors.forEach((error) => {
        const { instancePath, message } = error;
        const pathParts = instancePath.split('/');
        pathParts.shift()
        let currentVal = givenValue
        pathParts.forEach((part, index) => {
            if (index === pathParts.length - 1) {
                const casted = doTypeCast(currentVal[part], message)
                if (casted) {
                    currentVal[part] = casted
                } else {
                    unresolved.push(error)
                }
            } else {
                currentVal = currentVal[part]
            }
        })
    })
    return { typeCasted: givenValue, remainingErrors: unresolved }
}

export default function validate(name, schema, value) {
    if (!schema) {
        console.warn(`No schema given for ${name}`, value)
        return value
    }
    if (schema && !schema.validate(value)) {
        const { typeCasted, remainingErrors } = tryToTypeCast(value, schema.validate.errors);
        if (remainingErrors.length > 0) {
            if (window.strictValidate && isNotProduction) {
                console.error(`Given value for ${name}`, typeCasted)
                console.error(`Schema error found in ${name}:`, remainingErrors)
                throw `Schema error`
            }
        }
        return typeCasted;
    }
    return value
}